import * as React from 'react'

export default function useHighlightNumber() {
  const [sku, setSku] = React.useState('')

  React.useEffect(() => {
    const [, sku] = location.search.match(/number=([^&#]*)/) ?? []
    if (sku) setSku(sku)
  }, [])

  return sku
}
